import { render, staticRenderFns } from "./setting-languages.vue?vue&type=template&id=57d4be70&"
import script from "./setting-languages.vue?vue&type=script&lang=ts&"
export * from "./setting-languages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports